import axios from 'axios';
import base from '@/api/base.api';
const namespace = 'bank-statement/api-v1';

export default {
    findBankStatementByAccount: (params) => {
        return axios.post(`${base.baseUrlWallet}/${namespace}/list-by-account`, params)
    },
}
